import axios from "axios";
import * as types from '../constants/ActionTypes'

// Url's
// const getPincodeDataUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-state-city-by-zipcode`;

const getPincodeDataUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-state-city-by-zipcode`;


// Actions
const pincodeDataRequested = () => ({
    type: types.PINCODE_REQUEST
  });

const pincodeDataSuccess = data => ({
  type: types.PINCODE_SUCCESS,
  data
});

const pincodeDataFailure = error => ({
  type: types.PINCODE_FAILURE,
  error
});


// API
export const getPincodeData = (connection_id, pincode) => {
  return dispatch => {
    dispatch(pincodeDataRequested());
    axios.get(getPincodeDataUrl, {
      params: {
        connection_id,
        zipcode: pincode
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(pincodeDataSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(pincodeDataFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const getPincodeDataAxios =  async(connection_id, pincode) => {
  try {
    const response = await axios.get(getPincodeDataUrl, {
      params: {
        connection_id,
        zipcode: pincode
      },
    })
    return response.data
  } catch (error) {
    console.error(error);
  }
}

// module.exports.getPincodeDataAxios = getPincodeDataAxios;